import React from "react";
import { getGeneralStatus } from "../../data/flight/order/getStatusName";
import CopyText from "../mini/CopyText";
import { PriceBreakdown } from "./PirceBreakdown";
import ChangePriceBreakdown from "./ChangePriceBreakdown";
import { RefundPriceBreakdown } from "./RefundPirceBreakdown";



function getGeneralStatusPT(status) {
  if(status === 'Pending') return 'Awaiting Refund Value';
  const stat = getGeneralStatus(status);
  return stat;
}

function TicketManagementFlightOrderDetailStatusContainer({order,page,callback}) {
  const requestPage = page && page !== 'Ticket';

  console.log(order)
  
  const orderData = order?.booking?.flightBooking?.at(0);

  
  if(page === 'refund')
    return <RefundStatus {...{order,page}} callback={callback} />
  if(page === 'Change')
    return <ChangeStatus {...{order,page}} callback={callback} />

  return (
    <div className="flex flex-col w-full lg:w-[485px] border border-[#DBDBDB] bg-white rounded-md p-4 shadow-sm h-fit">
      <span className="text-sm lg:text-base mb-2 text-[#818083] ">Status</span>
      <Status value={page+' '+(!order?.confirmed ? getGeneralStatus(order?.status) : 'Priced')} />
      <div className="flex flex-row justify-between mt-4">
        <div className="flex flex-col">
          <span className="text-sm lg:text-base text-[#818083] ">Airline</span>
          <div className="flex items-center gap-2">
            <img
              src={orderData?.flights?.at(0)?.airlineImage}
              alt=""
              className="w-24 h-10 object-cover"
            />
            <span className="text-sm lg:text-base font-bold">
              {orderData?.flights?.at(0)?.arilineName}
            </span>
          </div>
        </div>
        <div className="flex flex-col items-end">
          <span className="text-sm lg:text-base text-[#818083] ">Date</span>
          <span className="text-sm lg:text-base font-bold">{orderData?.flights?.at(0)?.departureDate}</span>
        </div>
      </div>
      {requestPage ? 
        <div className="flex flex-col mt-4">
          <span className="text-sm lg:text-base text-[#818083] ">Change Order ID</span>
          <span className="text-sm lg:text-base font-bold flex gap-2">
            {order?.orderId}
            <CopyText>
              <input className="w-0" value={order?.orderId} />
            </CopyText>
          </span>
        </div>
      :
        <div className="flex flex-col mt-4">
          <span className="text-sm lg:text-base text-[#818083] ">Order ID</span>
          <span className="text-sm lg:text-base font-bold">{orderData?.bookingId}</span>
        </div>
      }
      <PriceBreakdown data={order} />
      {/* <span className="text-sm mt-4 mb-3 font-bold">Important info</span>
      <p className="mt-3 text-xs text-[#6D7C94] ">
        On rare occasions, ticketing of paid order may not be successful for
        many expected reasons such as the variety of booking class, INTRAVERSE
        may offer full refund of payments for the failure of issuance within 3
        hours of payment received.
      </p>
      <p className="mt-3 text-xs text-[#6D7C94] ">
        Please make sure the passport number is correct and the validity should
        be at least six month from date of departure of the last journey.
      </p>
      <p className="mt-3 text-xs text-[#6D7C94] ">
        INTRAVERSE strongly recommends that duplicate reservations are avoided.
        Merging and cancellation may occur within the airline system without
        prior notification. INTRAVERSE is not liable for any loss or damage.
      </p> */}
    </div>
  );
}


const RefundStatus = ({page,order}) => {
  return (
    <div className="flex flex-col w-full lg:w-[485px] border border-[#DBDBDB] bg-white rounded-md p-4 shadow-sm h-fit">
      <span className="text-sm lg:text-base font-bold mb-4 capitalize">{page}</span>
      <Status value={((!order?.confirmed || (['Denied','Canceled','Failed','Pending','Approved','Success']?.includes(order?.status))) ? getGeneralStatusPT(order?.status) : 'Priced')} stat={getGeneralStatusPT(order?.status)} />
      {/* {!order?.priceReceived && ['Pending']?.includes(order?.status) ? 
        <small className="py-2">
          {`The Intraverse system has pre-assessed that this ticket is refundable and the refund amount is displayed below for your reference. 
          Please note that the final refund price will be calculated by Airline when processing the refund. 
          If you have any questions about the price, feel free to request refund pricing for manual verification.)`}
        </small>
      :null} */}

      {order?.priceReceived ?
        <RefundPriceBreakdown data={order} />
      :null}

      {/* {page === 'refund' && !order?.priceReceived && ['Pending']?.includes(order?.status) ? 
        <div className="flex justify-center font-bold py-2">
          Refund price not verified
        </div>
      :null} */}
    </div>
  );
}

const ChangeStatus = ({page,order}) => {
  function internalStatus(status) {
    if(order?.status === 'Approved' && order?.changePrice && !order?.isConfirmed)
      return 'Awaiting Payment';
    return status;
  }

  return (
    <div className="flex flex-col gap-4 w-full lg:w-[485px] border border-[#DBDBDB] bg-white rounded-md p-4 shadow-sm h-fit">
      <span className="text-sm lg:text-base font-bold capitalize">{page}</span>
      {/* {order?.status === 'Approved' ? 
        <Status value={'Awaiting Payment'} stat={getGeneralStatus(order?.status)} />
      :
      } */}
      <Status value={((!order?.confirmed || (['Denied','Canceled','Failed']?.includes(order?.status))) ? internalStatus(getGeneralStatus(order?.status)) : 'Priced')} stat={getGeneralStatus(order?.status)} />
      {order?.changeFee || order?.changePrice ? 
        <ChangePriceBreakdown data={order} />
      :null}
    </div>
  );
}

const Status = ({value,stat:defStat}) => {
  const stat = (value||'')?.toLowerCase();
  const getColors = () => {
    switch (defStat?.toLowerCase()) {
      case "Success":
      case "success":
        return "text-[#0B662C] border-[#1EA994] bg-[#C4E9E3]";
      case "processing":
      case "pending":
      case "awaiting refund value":
        return "text-[#D9A513] border-[#D9A513] bg-[#D9A513]/20";
      case "rejected":
      case "canceled":
      case "closed":
        return "text-[#B52026] border-[#B52026] bg-[#B52026]/20";
      default:
        return "text-[#0B662C] border-[#1EA994] bg-[#C4E9E3]";
    }
  };
  return (
    <div
      className={`flex flex-col w-fit border-2 ${getColors()} px-4 rounded-md py-1 capitalize`}
    >
      {stat}
    </div>
  );
};


export default TicketManagementFlightOrderDetailStatusContainer;
